// Warm only the first screenful of the next batch, using the same responsive
// sources as the real cards. Detached Images do not change the page layout.
export function prefetchDiscoverImages(html, { document = globalThis.document,
  Image = globalThis.Image, connection = globalThis.navigator?.connection } = {}) {
  if (!html || connection?.saveData) return [];

  const template = document.createElement('template');
  template.innerHTML = html;
  return [...template.content.querySelectorAll('.ds-event-card__image-media')]
    .slice(0, 6).map(source => {
      const image = new Image();
      image.decoding = 'async';
      image.fetchPriority = 'low';
      // Set sizes before srcset so we warm the same candidate the card will use.
      for (const name of ['sizes', 'srcset', 'src']) {
        const value = source.getAttribute(name);
        if (value) image.setAttribute(name, value);
      }
      // Decoding is best effort: broken images must never block pagination.
      image.decode?.().catch(() => {});
      return image;
    });
}
